var EventEmitter = require('events').EventEmitter;
var debug = require('debug')('AuthStore');
var cookies = require('cookies-js');
var jwtDecode = require('jwt-decode');
var _ = require('underscore');
var Promise = require('bluebird');
var url = require('url');

// exposed at bottom of file
// as singleton

function AuthStore(){
  EventEmitter.call(this);
}

AuthStore.prototype = new EventEmitter;

AuthStore.prototype.setup = function($rootScope, $state){
  this.$rootScope = $rootScope;
  this.$state = $state;

  $rootScope.$on('$stateChangeStart', this.onPage.bind(this));

  this.checkInterval = setInterval(this.refresh.bind(this), 60 * 1000);
  this.parse();
  this.refresh();
};

// handles state change authentication
AuthStore.prototype.onPage = function(event, toState, toParams){
  var self = this;
  var auth = this.current;
  var data = toState.data || {};
  var authenticate = data.authenticate;
  this.currentPage = toState;

  if (data.fullHeader) {
    this.$rootScope.fullHeader = true;
  }

  // no authentication required
  if (!authenticate) {
    debug('nav to "%s" (unauth)', toState.name);
    return;
  }

  // no auth but route request auth
  if (!auth) {
    event.preventDefault();
    debug('nav to "%s" : requires auth - going to login', toState.name);

    var targetUrl = this.$state.href(toState, toParams);

    if (data.loginProcessParams) {
      var targetUrlObj = url.parse(targetUrl, true);
      // add loginParams to querystring and toParams
      // for encoding.
      var loginParams = data.loginProcessParams;
      for (var paramName in loginParams) {
        targetUrlObj.query['lp_' + paramName] = loginParams[paramName];
      }
      targetUrl = url.format(targetUrlObj);
    }

    // build redirect url
    var redirect = '/login?redirect=' + encodeURIComponent(targetUrl);
    window.location = redirect;
    return;
  }

  var claims = data.claims || [];
  var redirected = false;

  claims.forEach(function(claim){
    var matched = false;
    if (redirected) return;

    auth.claims.forEach(function(c){
      if (matched) return;
      if (claim.type == c.type && claim.value == c.value) {
        matched = true;
      }
    })

    // claim.bail is used to trigger the redirect in the case
    // the claim does exist.

    // if its matched and this claim isnt a bail claim.
    if (matched && !claim.bail) {
      debug('claim matched "%s" with value "%s" and didnt bail', claim.type, claim.value);
      return;
    }

    // if we are bailing, and this didnt match we can ignore.
    if (!matched && claim.bail) {
      debug('claim not found "%s" with value "%s" and bailed', claim.type, claim.value);
      return
    }

    redirected = true;

    if (claim.redirect) {
      event.preventDefault();
      debug('claim redirect "%s" with value "%s" - redirecting to %s', claim.type, claim.value, claim.redirect);
      window.location = claim.redirect;
      return;
    }

    if (claim.state) {
      event.preventDefault();
      debug('claim redirect "%s" with value "%s" - redirecting to state %s', claim.type, claim.value, claim.state);
      self.$state.go(claim.state);
      return;
    }

    throw new Error('somebody didnt specify a claim.state or claim.redirect')
  })

  if (auth) {
    debug('nav to "%s"', toState.name);
    return;
  }
};


// parses cookie from token every 30 seconds
// and checks if it still exists and is valid.
// If it expires soon, it will try and get a new one.

AuthStore.prototype.parse = function(opts, cb){
  opts = opts || {};
  var cookie = cookies.get(window.conf.token_cookie_name);
  this.token = cookie;

  if (!cookie) {
    debug('no token found');
    return this.diff() && this.remove();
  }

  try {
    // decode jwt
    var jwt = jwtDecode(cookie);
  } catch (e) {}


  if (!jwt) {
    debug('could not parse token');
    return this.diff() && this.remove();
  }

  if (!jwt.user_id) {
    debug('token has no user_id');
    return this.diff(jwt) && this.remove();
  }

  if (!jwt.expires) {
    debug('token has no expirey');
    return this.diff(jwt) && this.remove();
  }

  jwt.expires = new Date(jwt.expires);

  if (jwt.expires < new Date) {
    debug('token already expired');
    return this.diff(jwt) && this.remove();
  }

  // debug('has token with value %o', jwt);

  // we have a valid token and we will set it as
  // part of the current store, but only if its
  // different than before
  if (this.diff(jwt)) {
    debug('token was changed %o', jwt);
    this.current = jwt;
    this.change();
  }

  if (cb) {
    cb();
  }


  // if (opts.refresh) {
  //   this.refresh();
  // }

  // if jwt expires within ~5 minutes
  // var expires = (new Date(jwt.expires));
  // expires.setMinutes(expires.getMinutes() - 10);
  // if (new Date >= expires ) {
  //   debug('jwt expiring soon');
  //   this.refresh();
  // }

  return this.current;
};



AuthStore.prototype.diff = function(jwt){
  // if both are undefined, then nothing has changed
  if (!this.current && !jwt) {
    return;
  }

  // if both exist, and they both have same user and expiry
  // then nothing has changed
  if (this.current && jwt
     && this.current.user_id == jwt.user_id
     && this.current.expires && jwt.expires
     && this.current.expires.getTime() == jwt.expires.getTime()) {
    return;
  }

  return true;
};


AuthStore.prototype.remove = function(){
  delete this.current;
  this.change();
};

AuthStore.prototype.refresh = function(afterParse){
  if (!this.token) {
    debug('no token so not refreshing');
    return;
  }
  debug('emitting refresh');

  this.emit('refresh', this.parse.bind(this, {}, afterParse));
  // setTimeout(this.parse.bind(this), 2000);
};

AuthStore.prototype.change = function(){
  this.emit('change', this.current);

  // when no token, and current page requires auth, redirect.
  if (!this.current) {
    var page = this.currentPage;
    if (page && page.data && page.data.authenticate) {
      debug('no auth so redirecting from %s', page.url);
      window.location = '/login?redirect=' + encodeURIComponent(page.url);
    }
  }

  this.$rootScope.auth = this.current;
  if (!this.$rootScope.$$phase) this.$rootScope.$apply();
};


AuthStore.prototype.hasClaims = function(arr){
  var self = this;
  if (!this.current || !this.current.claims) return false;

  for (var n = 0; n < this.current.claims.length; n++) {
    var userClaim = this.current.claims[n];
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      // Types match and either both have no value or both have the same value regardless of case
      if ((userClaim.type == item.type) && 
          ((userClaim.value && item.value && userClaim.value.toLowerCase() == item.value.toLowerCase())
           || (!userClaim.value && !item.value))) {
        return true
      }
    }
  }

  return false;
};

AuthStore.prototype.getClaimValue = function(type){
  var self = this;
  if (!this.current || !this.current.claims) return null;

  for (var n = 0; n < this.current.claims.length; n++) {
    var userClaim = this.current.claims[n];
    if (userClaim.type == type) return userClaim.value;
  }

  return null;
}



module.exports = new AuthStore;
